import React from "react";
import { SmartLink } from "@/src/components/v2/SmartLink/SmartLink";

// Opens the Osano "Do Not Sell or Share My Personal Information" modal.
// Osano is injected globally via pages/_document.tsx; guard in case it
// hasn't loaded yet (e.g. blocked by a network/ad-blocker).
const handleDoNotSell = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    window.Osano?.cm?.showDoNotSell();
};

const Copy = () => {
    return (
        <div className="flex flex-col gap-5 text-xs text-text-contrast">
            <div className="flex flex-col gap-2">
                <p>* Reimbursement percent is based on your pet's age at the time of enrollment and renewal.</p>
                <p>1. 5% multi-pet discount on 2 pets enrolled. 10% discount on 3+ pets enrolled.</p>
                <p>2. Reimbursement for the eligible costs of alternative therapies, up to $1000/year.</p>
                <p>3. Reimbursement up to $25/day and $500/incident if you’re hospitalized for more than 48 hours.</p>
                <p>4. Reimbursement for costs of advertising and reward paid if your pet is lost or stolen.</p>
                <p>
                    5. No purchase necessary. Based on total combined Spot Perks discounts applied to avg. vendor cart value. 
                    <SmartLink href={"/perks-terms"}>Spotpetinsurance.ca/perks-terms</SmartLink>.
                </p>
                <p>
                    The information herein is summarized. All Pet Insurance plans have waiting periods, annual deductible, co-insurance, benefit limits and exclusions. Specific
                    products, features, coverage limits, rates, and discounts may vary by province, eligibility, and are subject to change. Medical Conditions that are noted,
                    symptomatic or diagnosed prior to enrollment, or during a waiting period are pre-existing to Coverage and not eligible for reimbursement. Coverage availability
                    varies by province. Not available in Quebec.
                </p>
                <p>
                    For all terms and conditions visit <SmartLink href={"/sample-policy"}>www.spotpetinsurance.ca/sample-policy</SmartLink>. Preventive Care reimbursements are
                    based on a schedule. Accident & Illness insurance reimbursements are based on eligible treatments and invoice amounts.
                </p>
                <p>
                    Insurance plans are underwritten by Northbridge General Insurance Corporation and administered by PTZ Insurance Services Ltd. Insurance plans are marketed and
                    produced by Spot Pet Insurance Services, ULC.
                </p>
            </div>
            <div className="flex flex-row flex-wrap-reverse gap-4">
                <div className="flex-1 max-md:basis-full">© {new Date().getFullYear()} Spot Pet Insurance Services, ULC. All Rights Reserved.</div>
                <SmartLink href="/terms-conditions">
                    <span className={`underline`}>Terms &amp; Conditions</span>
                </SmartLink>
                <SmartLink href="/privacy">
                    <span className={`underline`}>Privacy Policy</span>
                </SmartLink>
                <button type="button" onClick={handleDoNotSell} className="cursor-pointer text-left underline">
                    Do Not Sell or Share My Personal Information
                </button>
            </div>
        </div>
    );
};

export default Copy;
